document.addEventListener('DOMContentLoaded', function() {
    const scrollProgress = document.querySelector('.scroll-progress');
    const scrollTrack = document.querySelector('.scroll-progress__track');
    const scrollThumb = document.querySelector('.scroll-progress__thumb');
    
    if (!scrollProgress || !scrollTrack || !scrollThumb) {
        console.log('Scroll indicator elements not found');
        return;
    }

    // Find the scrollable pricing container - try multiple selectors
    let scrollContainer = null;
    
    const selectors = [
        '.pricing-content.desktop',
    ];
    
    for (let selector of selectors) {
        const element = document.querySelector(selector);
        if (element && element.scrollWidth > element.clientWidth) {
            scrollContainer = element;
            console.log('Found scrollable container:', selector);
            break;
        }
    }

    if (!scrollContainer) {
        console.log('No scrollable container found, hiding indicator');
        scrollProgress.style.display = 'none';
        return;
    }

    // Update scroll thumb position based on scroll
    function updateScrollThumb() {
        const scrollLeft = scrollContainer.scrollLeft;
        const scrollWidth = scrollContainer.scrollWidth;
        const clientWidth = scrollContainer.clientWidth;
        
        if (scrollWidth <= clientWidth) {
            scrollProgress.style.display = 'none';
            return;
        }
        
        scrollProgress.style.display = 'flex';
        
        const maxScroll = scrollWidth - clientWidth;
        const scrollPercentage = scrollLeft / maxScroll;
        const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 15);
        const maxPosition = 100 - thumbWidth;
        
        scrollThumb.style.width = `${thumbWidth}%`;
        scrollThumb.style.left = `${scrollPercentage * maxPosition}%`;
        
        console.log('Scroll updated:', {
            scrollLeft,
            scrollWidth,
            clientWidth,
            scrollPercentage,
            thumbWidth
        });
    }

    // Handle clicking on track to scroll
    scrollTrack.addEventListener('click', function(e) {
        const rect = scrollTrack.getBoundingClientRect();
        const clickPosition = (e.clientX - rect.left) / rect.width;
        const scrollWidth = scrollContainer.scrollWidth;
        const clientWidth = scrollContainer.clientWidth;
        const maxScroll = scrollWidth - clientWidth;
        
        scrollContainer.scrollTo({
            left: clickPosition * maxScroll,
            behavior: 'smooth'
        });
    });

    // Listen for scroll events
    scrollContainer.addEventListener('scroll', updateScrollThumb);
    
    // Listen for resize events
    window.addEventListener('resize', function() {
        setTimeout(updateScrollThumb, 100);
    });
    
    // Initial update with delay to ensure DOM is ready
    setTimeout(() => {
        updateScrollThumb();
    }, 500);
    
    console.log('Scroll indicator initialized for:', scrollContainer);
}); 
